import React from 'react';
export var IconArrowSmall = /*#__PURE__*/React.memo(function (_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    fill: "none",
    height: 10,
    viewBox: "0 0 6 10",
    width: 6,
    xmlns: "http://www.w3.org/2000/svg",
    "data-t-id": "assets-IconArrowSmall"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 5 .3 1.7l1-1L5.5 5 1.3 9.2l-1-.9L3.6 5Z",
    fill: "#8e8e9f"
  }));
});
IconArrowSmall.displayName = IconArrowSmall.name;